import createIcon from '../../createIcon';

/**
 * @component @name SettingsEthernet
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNy43Njk4MiA2Ljc1OTk4TDYuMjI5ODIgNS40Nzk5OEwwLjgxOTgyNCAxMkw2LjIyOTgyIDE4LjUyTDcuNzY5ODIgMTcuMjRMMy40MTk4MiAxMkw3Ljc2OTgyIDYuNzU5OThaTTYuOTk5ODIgMTNIOC45OTk4MlYxMUg2Ljk5OTgyVjEzWk0xNi45OTk4IDExSDE0Ljk5OThWMTNIMTYuOTk5OFYxMVpNMTAuOTk5OCAxM0gxMi45OTk4VjExSDEwLjk5OThWMTNaTTE3Ljc2OTggNS40Nzk5OEwxNi4yMjk4IDYuNzU5OThMMjAuNTc5OCAxMkwxNi4yMjk4IDE3LjI0TDE3Ljc2OTggMTguNTJMMjMuMTc5OCAxMkwxNy43Njk4IDUuNDc5OThaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const SettingsEthernet = createIcon('SettingsEthernet', [
  [
    'path',
    {
      d: 'M7.76982 6.75998L6.22982 5.47998L0.819824 12L6.22982 18.52L7.76982 17.24L3.41982 12L7.76982 6.75998ZM6.99982 13H8.99982V11H6.99982V13ZM16.9998 11H14.9998V13H16.9998V11ZM10.9998 13H12.9998V11H10.9998V13ZM17.7698 5.47998L16.2298 6.75998L20.5798 12L16.2298 17.24L17.7698 18.52L23.1798 12L17.7698 5.47998Z',
      key: '1tcr5n',
    },
  ],
]);

export default SettingsEthernet;
